<template>
<div>
  
  <div class="section text-center" id="projects">
      <div class="container-fluid text-center">
        <h2 class="title">{{ $t('index.title') }}</h2>
        <h4>{{ $t('index.subtitle') }}</h4>
        <div class="col-md-12 ml-auto mr-auto">
          <div class="row collections">
            <project-list-view status="abierto"></project-list-view>
          </div>
            
        </div>
      </div>
      
      <el-divider></el-divider>

      <h3>{{ $t('index.title_closed') }}</h3>
      <div class="container-fluid text-center">
        <div class="col-md-12 ml-auto mr-auto">
            <div class="row collections">
              <project-list-view status="cerrado"></project-list-view>
            </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import { Alert, Pagination } from '@/components';
import { Divider } from 'element-ui'

import ProjectListView from '../../pages/components/ProjectListView';

export default {
  name: 'panel-overview',
  components: {
    [Pagination.name]: Pagination,
    [Divider.name]: Divider,
    Alert,
    ProjectListView
  },
  data() {
    return {
      
    }
  },
  mounted() {
  },
  methods: {
  },
  watch: {
  }
};
</script>
<style>
</style>
